import React, { useEffect, useState } from "react";
import { Button, makeStyles, Grid } from "@material-ui/core";
import { Menu, MenuItem, TextField } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { ppodData } from "../../../assets/lib/ppod";
import {
  CustomModal,
  SingleInputField,
  TwoInputField,
} from "../../../components";

const customStyle = makeStyles({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  formLabel: {
    fontSize: "16px",
    fontWeight: "bold",
  },
});

const PodModal = (props) => {
  const {
    setIsModalOpen,
    isModalOpen,
    handleSubmitModal,
    podState,
    getPodInput,
    errorFields,
    loadingModal,
    pusersData,
    pusersMenu,
    setPusersMenu,
  } = props;
  const classes = customStyle();
  const [anchorElCampus, setAnchorElCampus] = useState(null);

  const onChangeMenuItemPusers = (item) => {
    setPusersMenu(item);
    setAnchorElCampus(null);
  };

  useEffect(() => {
    if (pusersData.length > 0) {
      setPusersMenu(pusersData[0]);
    }
  }, [pusersData]);

  return (
    <CustomModal
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onSubmit={handleSubmitModal}
      showLoading={loadingModal}
    >
      <div className={classes.formContainer}>
        <TwoInputField
          content={ppodData.ppodNumber}
          value={podState.ppodNumber}
          isEditable={false}
          secondContent={ppodData.location}
          secondValue={podState.location}
          errorFields={errorFields}
          getInputData={getPodInput}
        />
        <Grid container spacing={2}>

          <Grid item xs={6}>
            <div className={classes.formGroup}>
              <span className={classes.formLabel}>User Id :</span>
              <Button
                aria-controls="dropdown-menu"
                aria-haspopup="true"
                onClick={(event) => setAnchorElCampus(event.currentTarget)}
                variant="contained"
                style={{  textTransform: 'none' ,borderRadius:"6px",fontFamily: 'Inter, sans-serif',backgroundColor:"#8b003c",color:"white"}}
                endIcon={<KeyboardArrowDownIcon />}
              >
                {pusersMenu?.userId}
                          </Button>
                          <Menu
              id="dropdown-menu"
              anchorEl={anchorElCampus}
              keepMounted
              open={Boolean(anchorElCampus)}
              onClose={() => setAnchorElCampus(null)}
              PaperProps={{
                style: {
                  maxHeight: 200,
                  width: '150px',
                  whiteSpace: 'normal',  // <-- allow wrapping
                },
              }}
            >
              {pusersData.map((pusers, index) => (
                <MenuItem
                  onClick={() => onChangeMenuItemPusers(pusers)}
                  key={index}
                  style={{
                    whiteSpace: "normal", // <-- allow text wrap
                    wordBreak: "break-word", // <-- handle long strings
                    padding: "10px 16px",
                  }}
                >
                  {pusers?.userId}
                </MenuItem>
              ))}
            </Menu>

            </div>
          </Grid>
        </Grid>
      </div>
    </CustomModal>
  );
};

export default PodModal;
